import { faSpinnerThird } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Space } from "antd";

const SubmitButton = ({
  disabled,
  submitting,
  type,
  block = false,
  children,
  size,
}) => {
  return (
    <Button
      htmlType="submit"
      disabled={disabled || submitting}
      type={type}
      block={block}
      size={size}
    >
      {submitting ? (
        <Space>
          <FontAwesomeIcon
            icon={faSpinnerThird}
            className="fa-spin"
            style={{ "--fa-animation-duration": "1s" }}
          />{" "}
          Submitting
        </Space>
      ) : (
        children
      )}
    </Button>
  );
};

export default SubmitButton;
